// @flow

import type { AppType } from "shared/types/AppType"

export default ({
  asyncComponentResolve: () => import("apps/user/User"),
  orderPrio: 100,
  iconType: "team",
  name: "users",
  subApps: [
    {
      name: "system-users",
      requirePermission: "user:view"
    },
    {
      name: "travelers",
      requirePermission: "user:traveler-view"
    },
    {
      name: "import",
      requirePermission: "user:traveler-view"
    }
  ]
}: AppType)
